import {actionMap} from '../reducers/index'
import handleError from 'shared/errorHandler/actions/handleError'
import {fetchApi} from "shared/actions/fetchApi"
import * as types from './types'

export default () => dispatch => {
    dispatch({type: types.GET_USERNAME_START})
    return fetchApi("/api/as/auth/username")
        .then(response => response.json())
        .then(response => {
            dispatch({
                type: types.GET_USERNAME_SUCCESS, response: response
            })
        })
        .catch(error => {
            dispatch({
                type: types.GET_USERNAME_FAILURE
            })
            dispatch(handleError({
                message: error.message,
                title: "Error occurred while trying to establish connection to authentication service"
            }))
        })
}

export const handler_GET_USERNAME_START = (reduxState) => {
    return ({
        ...reduxState
    })
}

export const handler_GET_USERNAME_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        username: action.response.username,
        authenticated: action.response.authenticated
    })
}

export const handler_GET_USERNAME_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        username: undefined,
        authenticated: false
    })
}

actionMap[types.GET_USERNAME_START] = handler_GET_USERNAME_START
actionMap[types.GET_USERNAME_SUCCESS] = handler_GET_USERNAME_SUCCESS
actionMap[types.GET_USERNAME_FAILURE] = handler_GET_USERNAME_FAILURE


// WEBPACK FOOTER //
// ./src/screens/login/actions/getUsername.js